// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"da66ec5f","513":"2882569d","545":"ed4a9f83","787":"41082a70"}[chunkId] + ".chunk.js";
};